import { UNITRENDS_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const unitrendsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUnitrendsJobs: builder.query({
            query: () => ({
                url: `${UNITRENDS_URL}`,
            }),
            keepUnusedDataFor: 5
        }),
    })
});

export const { useGetUnitrendsJobsQuery } = unitrendsApiSlice;
